export const menuItems = [
    {
        to: '/dashboard',
        title: 'Dashboard',
        icon: '/media/icons/duotune/general/gen001.svg',
        fontIcon: 'bi-app-indicator',
        module: 'dashboard'
    },
    {
        to: '',
        title: 'Universal Module',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/general/gen022.svg',
        module: 'UniversalModule',
        subMenuItems: [
            {
                to: '',
                title: 'Geo Locations',
                icon: '/media/icons/duotune/abstract/abs027.svg',
                module: 'company-management',
                subMenuItems: [
                    {
                        to: '/admin/location/country',
                        title: 'Country',
                        hasBullet: true,
                        module: 'company-management'
                    },
                    {
                        to: '/admin/location/state',
                        title: 'State',
                        hasBullet: true,
                        module: 'company-management'
                    },
                    {
                        to: '/admin/location/district',
                        title: 'District',
                        hasBullet: true,
                        module: 'company-management'
                    },
                    {
                        to: '/admin/location/pincode',
                        title: 'Pincode',
                        hasBullet: true,
                        module: 'company-management'
                    },
                ],
            },
        ],
    },
    {
        to: '/apps/company-management/emp_user',
        title: 'Admin User',
        icon: '/media/icons/duotune/communication/com013.svg',
        fontIcon: 'bi-app-indicator',
        module: 'IIPRLUser'
    },
    {
        to: '/admin/company/list',
        title: 'Manage Company',
        icon: '/media/icons/duotune/layouts/lay009.svg',
        fontIcon: 'bi-app-indicator',
        module: 'company-management'
    },


    {
        to: '',
        title: 'KYC Management',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/technology/teh002.svg',
        module: 'KYC',
        subMenuItems: [
            {
                to: '/admin/kyc/user',
                title: 'User KYC QC',
                hasBullet: true,
                module: 'KYC'
            },

            {
                to: '/admin/kyc/docs',
                title: 'User Docs',
                hasBullet: true,
                module: 'KYC'
            },

            {
                to: '/admin/kyc/upload/bank',
                title: 'Bank Upload',
                hasBullet: true,
                module: 'KYC'
            },
            {
                to: '/admin/kyc/upload/pan',
                title: 'Pan Upload',
                hasBullet: true,
                module: 'KYC'
            },
            {
                to: '/admin/kyc/request?request_type=register_user_pan',
                title: 'TooManyRequest',
                hasBullet: true,
                module: 'KYC'
            },

        ],
    },

    {
        to: '',
        title: 'Gift Products',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm007.svg',
        module: 'product',
        subMenuItems: [
            {
                to: '/admin/product/brand',
                title: 'Brand',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/attribute',
                title: 'Attribute',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/business_segment',
                title: 'Business Segment',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sub_business_segment',
                title: 'Sub Business Segment',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/category',
                title: 'Category',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sub_category',
                title: 'Sub Category',
                hasBullet: true,
                module: 'product'
            },

            {
                to: '/admin/product/list',
                title: 'Product',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sku',
                title: 'SKUs',
                hasBullet: true,
                module: 'product'
            },
        ],
    },
    {
        to: '',
        title: 'Vendors & Couriers',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm001.svg',
        module: 'courier',
        subMenuItems: [
            {
                to: '/admin/redeOtherPage/vendor',
                title: 'Vendor',
                hasBullet: true,
                module: 'courier'
            },
            // {
            //     to: '/admin/redeOtherPage/mapping_pincode/upload',
            //     title: 'Vendor Pincode Upload',
            //     hasBullet: true,
            //     module: 'courier'
            // },

            {
                to: '/admin/redeOtherPage/delivery-partner',
                title: 'Local Partner',
                hasBullet: true,
                module: 'courier'
            },
            {
                to: '/admin/courier/company',
                title: 'Courier Company',
                hasBullet: true,
                module: 'courier'
            },
            {
                to: '/admin/courier/partner',
                title: 'Courier Partner',
                hasBullet: true,
                module: 'courier'
            },

            {
                to: '/admin/courier/pick_up_location',
                title: 'Pick Up Location',
                hasBullet: true,
                module: 'courier'
            },
        ],
    },

    {
        to: '',
        title: 'Dispatch',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm005.svg',
        module: 'fullfillment',
        subMenuItems: [
            {
                to: '/admin/fullfillment/new_dispatch/list',
                title: 'Fullfillment',
                hasBullet: true,
                module: 'fullfillment',
            },
            {
                to: '/admin/fullfillment/new_dispatch/exception/list',
                title: 'Exception List',
                hasBullet: true,
                module: 'fullfillment',
            },

        ],
    },
    {
        to: '',
        title: 'Exception',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm005.svg',
        module: 'fullfillment',
        subMenuItems: [
            {
                to: '/apps/company-management/invoices/exception/list',
                title: 'Invoice Exception List',
                hasBullet: true,
                module: 'fullfillment',
            },


        ],
    },
    {
        to: '',
        title: 'Warehouse FullfillMent',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/finance/fin001.svg',
        module: 'Warehouse-Services',
        subMenuItems: [
            {
                to: '/admin/warehouse-fullfillment/new_dispatch/list',
                title: 'Upcoming Dispatch',
                hasBullet: true,
                module: 'Warehouse-Services',
            },

            {
                to: 'admin/warehouse-fullfillment/courier/assign',
                title: 'Courier Assign',
                hasBullet: true,
                module: 'Warehouse-Services',
            },

        ],
    },
    {
        to: '',
        title: 'Telecalling',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com005.svg',
        module: 'telecalling',
        subMenuItems: [

            {
                title: 'Support',
                icon: '/media/icons/duotune/abstract/abs027.svg',
                module: 'supportCalling',
                subMenuItems: [
                    {
                        to: 'admin/telecalling/support/outbound_list',
                        title: 'Call',
                        hasBullet: true,
                        module: 'supportCalling',
                    },
                    {
                        to: 'admin/telecalling/support/search_and_call_list',
                        title: 'Search & Call',
                        hasBullet: true,
                        module: 'supportCalling',
                    },

                    {
                        to: 'admin/telecalling/support/recall_list',
                        title: 'Recall Calls',
                        hasBullet: true,
                        module: 'supportCalling',
                    },
                    {
                        to: 'admin/telecalling/support/call_in_progress',
                        title: 'Calls In Progress',
                        hasBullet: true,
                        module: 'supportCalling',
                    },
                    {
                        to: 'admin/telecalling/support/closed_call',
                        title: 'Recently Closed Calls',
                        hasBullet: true,
                        module: 'supportCalling',
                    },
                    {
                        to: 'admin/telecalling/support/inbound_call/8968534405',
                        title: 'Inbound Calls',
                        hasBullet: true,
                        module: 'supportCalling',
                    },
                ]
            },
            {

                title: 'Leads',
                icon: '/media/icons/duotune/abstract/abs027.svg',
                module: 'telecalling',
                subMenuItems: [
                    {
                        to: 'admin/telecalling/leads_call_fresh',
                        title: 'Fresh Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/leads_re_call',
                        title: 'Recall Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/leads_call_in_progress',
                        title: 'Calls In Progress',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/leads_closed_call',
                        title: 'Recently Closed Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },
                    {
                        to: 'admin/telecalling/leads/report/list',
                        title: 'Lead Reports list',
                        hasBullet: true,
                        module: 'telecalling',
                    },
                ]

            },
            {

                title: 'Custom Calls',
                icon: '/media/icons/duotune/abstract/abs027.svg',
                module: 'telecalling',
                subMenuItems: [
                    {
                        to: 'admin/telecalling/custom_call_fresh',
                        title: 'Fresh Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/custom_re_call',
                        title: 'Recall Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/custom_call_in_progress',
                        title: 'Calls In Progress',
                        hasBullet: true,
                        module: 'telecalling',
                    },

                    {
                        to: 'admin/telecalling/custom_closed_call',
                        title: 'Recently Closed Calls',
                        hasBullet: true,
                        module: 'telecalling',
                    },
                    // {
                    //     to: 'admin/telecalling/leads/report/list',
                    //     title: 'Lead Reports list',
                    //     hasBullet: true,
                    //     module: 'telecalling',
                    // },
                ]

            },

        ],
    },
    // {
    //     to: '',
    //     title: 'Tele Callings',
    //     fontIcon: 'bi-telephone',
    //     icon: '/media/icons/duotune/communication/com011.svg',
    //     module: 'telecalling',
    //     subMenuItems: [
    //         {
    //             to: 'admin/tele-calling/support',
    //             title: 'Support Calling',
    //             hasBullet: true,
    //             module: 'telecalling',
    //         },
    //         {
    //             to: 'admin/tele-calling/custom',
    //             title: 'Custom Calling',
    //             hasBullet: true,
    //             module: 'telecalling',
    //         },
    //         {
    //             to: 'admin/tele-calling/Lead',
    //             title: 'Lead Calling',
    //             hasBullet: true,
    //             module: 'telecalling',
    //         },
    //     ],
    // },

    {
        to: '',
        title: 'Telecalling helper',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com008.svg', module: 'feedtelecalling',
        subMenuItems: [
            {
                to: 'admin/telecalling/must_tell/list',
                title: 'Must Tell',
                hasBullet: true, module: 'must_tell',
            },
            {
                to: 'admin/telecalling/complaint_feed/list',
                title: 'Complaints Subject',
                hasBullet: true, module: 'telecalling',
            },
            {
                to: 'admin/telecalling/subject/list',
                title: 'Other Subject',
                hasBullet: true, module: 'telecalling',
            },
            {
                to: 'admin/telecalling/product_pitch/list',
                title: 'Product Pitch',
                hasBullet: true, module: 'product_pitch',
            },
            {
                to: 'admin/telecalling/crop_detail/list',
                title: 'Crop Detail',
                hasBullet: true, module: 'crop_detail',
            },
        ],
    },

    {
        to: '',
        title: 'Communication',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com014.svg',
        module: 'communication',
        subMenuItems: [
            {
                to: 'admin/communication/trigger',
                title: 'Trigger',
                hasBullet: true,
                module: 'communication'
            },
            {
                to: 'admin/communication/sms',
                title: 'SMS',
                hasBullet: true,
                module: 'communication'
            },
            {
                to: 'admin/communication/whatsapp',
                title: 'Whatsapp',
                hasBullet: true,
                module: 'communication'
            },
            {
                to: 'admin/communication/email',
                title: 'Email',
                hasBullet: true,
                module: 'communication',
            },
            {
                to: 'admin/configuration/list',
                title: 'API Configuration',
                hasBullet: true,
                module: 'communication',
            },
            // {
            //     to: 'admin/communication/feedback',
            //     title: 'Call Feedback',
            //     hasBullet: true,
            //     module: 'communication',
            // },
        ],
    },
    {
        to: '',
        title: 'Compliants',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com004.svg', module: 'FAQs',
        subMenuItems: [

            {
                to: '/admin/complaint/all',
                hasBullet: true,
                title: 'All ', module: 'FAQs',
            },
            {
                to: '/admin/complaint/all/open',
                hasBullet: true,
                title: 'Open ', module: 'FAQs',
            },
            {
                to: '/admin/complaint/all/hold',
                hasBullet: true,
                title: 'On Hold', module: 'FAQs',
            },
            {
                to: '/admin/complaint/all/resolved',
                hasBullet: true,
                title: 'Resolved', module: 'FAQs',
            },
            {
                to: '/admin/complaint/all/close',
                hasBullet: true,
                title: 'Close', module: 'FAQs',
            },
        ],
    },
    // {
    //     to: '',
    //     title: 'Comm. Media',
    //     fontIcon: 'bi-archive',
    //     icon: '/media/icons/duotune/graphs/gra010.svg', module: 'Media',
    //     subMenuItems: [

    //         {
    //             to: '/admin/media/list',
    //             hasBullet: true,
    //             title: 'List', module: 'Media',
    //         },
    //     ],
    // },

    // {
    //     to: '',
    //     title: 'FAQs',
    //     fontIcon: 'bi-archive',
    //     icon: '/media/icons/duotune/text/txt004.svg', module: 'FAQs',
    //     subMenuItems: [

    //         {
    //             to: '/admin/faq/category_faq',
    //             hasBullet: true,
    //             title: 'Category', module: 'FAQs',
    //         },
    //         {
    //             to: '/admin/faq/list',
    //             hasBullet: true,
    //             title: 'List', module: 'FAQs',
    //         },
    //     ],
    // },




    // {
    //     to: '/admin/roles/list',
    //     title: 'Roles Manage',
    //     icon: '/media/icons/duotune/art/art002.svg',
    //     module: 'roles'
    // },
    {
        to: '/admin/role-report-assignment/assign',
        title: 'Module & Report Assignment',
        icon: '/media/icons/duotune/general/gen049.svg',
        fontIcon: 'bi-people',
        module: 'roles'
    },
    {
        to: 'admin/badge/list',
        title: 'Badges',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/general/gen056.svg',
        module: 'courier',

    },

    // {
    //     to: '',
    //     title: 'Order',
    //     fontIcon: 'bi-archive',
    //     icon: '/media/icons/duotune/ecommerce/ecm001.svg', module: 'order',
    //     subMenuItems: [
    //         {
    //             to: 'admin/distributor/order/all',
    //             title: 'All Order',
    //             hasBullet: true, module: 'order',
    //         },
    //         {
    //             to: 'admin/distributor/order/fresh',
    //             title: 'Fresh Order',
    //             hasBullet: true, module: 'order',
    //         },
    //         {
    //             to: 'admin/distributor/order/accept',
    //             title: 'Accepted Order',
    //             hasBullet: true, module: 'order',
    //         },
    //         {
    //             to: 'admin/distributor/order/partial',
    //             title: 'Partial Accept',
    //             hasBullet: true, module: 'order',
    //         },
    //         {
    //             to: 'admin/distributor/order/reject',
    //             title: 'Rejected Order',
    //             hasBullet: true, module: 'order',
    //         },
    //     ],
    // },
];
export const companyMenuItems = [
    {
        to: '/dashboard',
        title: 'Dashboard',
        icon: '/media/icons/duotune/general/gen001.svg',
        fontIcon: 'bi-app-indicator',
        module: 'dashboard'
    },
    {
        to: '/admin/project/list',
        title: 'Project Management',
        icon: '/media/icons/duotune/layouts/lay002.svg',
        fontIcon: 'bi-app-indicator',
        module: 'projects'
    },
    {
        to: '/apps/company-management/end_user',
        title: 'User Management',
        icon: '/media/icons/duotune/communication/com013.svg',
        fontIcon: 'bi-app-indicator',
        module: 'company-management'
    },
    {
        to: '/apps/company-management/lucky_draw',
        title: 'Lucky Draw Upload',
        icon: '/media/icons/duotune/technology/teh008.svg',
        fontIcon: 'bi-app-indicator',
        module: 'company-management'
    },
    {
        to: '',
        title: 'Co. Products',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm007.svg', module: 'product',
        subMenuItems: [
            {
                to: '/admin/product/brand',
                title: 'Brand',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/attribute',
                title: 'Attribute',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/business_segment',
                title: 'Business Segment',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sub_business_segment',
                title: 'Sub Business Segment',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/category',
                title: 'Category',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sub_category',
                title: 'Sub Category',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/list',
                title: 'Product',
                hasBullet: true,
                module: 'product'
            },
            {
                to: '/admin/product/sku',
                title: 'SKUs',
                hasBullet: true,
                module: 'product'
            },
        ],
    },

    {
        to: '',
        title: 'Profile/KYC',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/graphs/gra010.svg',
        module: 'KYC',
        subMenuItems: [
            {
                to: '/admin/kyc/user',
                title: 'Kyc User',
                hasBullet: true,
                module: 'KYC'
            },
            {
                to: '/admin/kyc/docs',
                title: 'User Docs',
                hasBullet: true,
                module: 'KYC'
            },
        ],
    },
]

// IIPRL Comapny
export const IIPRLMenuItems = [
    {
        to: '/dashboard',
        title: 'Dashboard',
        icon: '/media/icons/duotune/general/gen001.svg',
        fontIcon: 'bi-app-indicator',
        module: 'dashboard'
    },
    {
        to: '/apps/company-management/emp_user',
        title: 'User Management',
        icon: '/media/icons/duotune/communication/com013.svg',
        fontIcon: 'bi-app-indicator',
        module: 'company-management'
    },
    {
        to: '',
        title: 'Reports',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/finance/fin001.svg',
        module: 'reports',
        subMenuItems: [
            {
                to: 'admin/reports/form_leads_report',
                title: 'Lead Reports',
                hasBullet: true,
                module: 'reports',
            },

        ],
    },


]

// project dashboard Item

export const projectMenuItems = [
    {
        to: '/dashboard',
        title: 'Dashboard',
        icon: '/media/icons/duotune/general/gen001.svg',
        fontIcon: 'bi-app-indicator',
        module: 'dashboard'
    },
    {
        to: '',
        title: 'Hierarchy',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/abstract/abs027.svg', module: 'projects',
        subMenuItems: [
            {
                to: '/apps/company-management/structure',
                hasBullet: true,
                title: 'Structure',
                fontIcon: 'bi-app-indicator',
                module: 'projects',
            },
            {
                to: '/apps/company-management/designation',
                hasBullet: true,
                title: 'Designation',
                module: 'projects',
            },
            {
                to: '/apps/company-management/cluster/list',
                hasBullet: true,
                title: 'Cluster',
                fontIcon: 'bi-app-indicator',
                module: 'projects',
            },

            {
                to: '/apps/company-management/offices',
                hasBullet: true,
                title: 'Offices',
                fontIcon: 'bi-app-indicator',
                module: 'projects',
            },



            // {
            //     to: '/admin/project-roles/list',
            //     hasBullet: true,
            //     title: 'Roles',
            //     fontIcon: 'bi-app-indicator',
            //     module: 'roles',
            // },
            {
                to: '/admin/role-report-assignment/assign',
                title: 'Module & Report Assignment',
                icon: '/media/icons/duotune/general/gen049.svg',
                fontIcon: 'bi-people',
                module: 'roles'
            },
            // {
            //     to: '/apps/company-management/user-type',
            //     hasBullet: true,
            //     title: 'User Type',
            //     module: 'company-management',
            // },
        ],
    },

    {
        to: '',
        title: 'User management',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com013.svg',
        module: 'projects',
        subMenuItems: [
            {
                to: '/apps/company-management/project_end_user',
                hasBullet: true,
                title: 'End User',
                module: 'company-management',
            },
            {
                to: '/apps/company-management/co_user',
                hasBullet: true,
                title: 'Co. user',
                module: 'company-management',
            },
            {
                to: 'admin/badge/list',
                title: 'Badges',
                hasBullet: true,
                module: 'company-management',

            },
            {
                to: '/apps/company-management/user-mapping/list',
                hasBullet: true,
                title: 'Co.User Report Mapping',
                fontIcon: 'bi-app-indicator',
                module: 'projects',
            },
            // {
            //     to: '/apps/company-management/user_coupon_code/upload',
            //     hasBullet: true,
            //     title: 'Coupon Upload',
            //     module: 'UserCouponUpload',
            // },
            {
                to: '/apps/company-management/end_user/upload-ledger',
                hasBullet: true,
                title: 'Ledger Upload',
                module: 'UserLedgerUpload',
            },
            {
                to: '/apps/company-management/project_end_user/lead_call_upload',
                hasBullet: true,
                title: 'LeadCall Upload',
                module: 'company-management',
            },
            {
                to: '/apps/company-management/project_end_user/consumer_survey_upload',
                hasBullet: true,
                title: 'Custom Call Upload',
                module: 'company-management',
            },
            // {
            //     to: '/apps/company-management/project_end_user/upload_pincode',
            //     hasBullet: true,
            //     title: 'Pincode Mapping',
            //     module: 'company-management',
            // },
            // {
            //     to: '/apps/company-management/project_end_user/voucher_coupon_code',
            //     hasBullet: true,
            //     title: 'Upload Voucher Code',
            //     module: 'UploadVoucherCode',
            // },
            // {
            //     to: '/apps/company-management/project_end_user/user_purchase',
            //     hasBullet: true,
            //     title: 'Upload Purchase',
            //     module: 'userpurchase',
            // },
            {
                to: '/apps/company-management/add_slab_data',
                hasBullet: true,
                title: 'Add Purchase Slab',
                module: 'userpurchase',
            },
            {
                to: '/apps/company-management/project_end_user/upload-rrk-offer-skip-user',
                hasBullet: true,
                title: 'RRK Offer Skip User',
                module: 'company-management',
            },
            {
                to: "/apps/company-management/project_end_user/update_purchase",
                hasBullet: true,
                title: 'Update Purchase',
                module: 'company-management',
            }

        ],
    },
    {
        to: '/apps/company-management/mapping',
        icon: '/media/icons/duotune/abstract/abs027.svg',
        title: 'All Mapping',
        module: 'projects',
        fontIcon: 'bi-app-indicator',
    },
    {
        to: '',
        title: 'Offer Management',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/ecommerce/ecm009.svg',
        module: 'ProjectOffer',
        subMenuItems: [
            {
                to: '/apps/offer-management/project_scheme',
                title: 'Parent Offer',
                hasBullet: true,
                module: 'ProjectOffer'
            },

            {
                to: '/apps/offer-management/sub-offer',
                title: 'Offer',
                hasBullet: true,
                module: 'ProjectOffer'
            },
            {
                to: '/apps/offer-management/upload/user_purchase',
                title: 'Upload Purchase',
                hasBullet: true,
                module: 'ProjectOffer'
            },
            {
                to: '/apps/offer-management/upload/upload-ledger',
                title: 'Upload Payment',
                hasBullet: true,
                module: 'ProjectOffer'
            },
            {
                to: '/apps/offer-management/offer-report',
                title: 'Offer Report',
                hasBullet: true,
                module: 'ProjectOffer'
            },


        ],
    },
    {
        to: '/admin/product/project-sku',
        icon: '/media/icons/duotune/ecommerce/ecm007.svg',
        title: 'Products',
        module: 'projects',
        fontIcon: 'bi-app-indicator',
    },
    {
        to: '/apps/company-management/redemption',
        icon: '/media/icons/duotune/ecommerce/ecm004.svg',
        title: 'Redemptions',
        module: 'redemption-catalogue',
        fontIcon: 'bi-app-indicator',
    },
    {
        to: '/apps/company-management/r_partner/list',
        title: 'Redemption Partner',
        icon: '/media/icons/duotune/social/soc002.svg',
        fontIcon: 'bi-app-indicator',
        module: 'projects',
    },
    {
        to: '/apps/company-management/auto_call',
        title: 'Auto Call Generate',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/electronics/elc002.svg',
        module: 'projects',

    },
    {
        to: '/apps/company-user/upload-notes',
        title: 'End User Note',
        icon: '/media/icons/duotune/communication/com012.svg',
        fontIcon: 'bi-app-indicator',
        module: 'projects',
    },

    {
        to: '/apps/company-management/forms',
        icon: '/media/icons/duotune/text/txt002.svg',
        title: 'Form',
        module: 'form_leads',
        fontIcon: 'bi-app-indicator',
    },
    {
        to: '/apps/company-management/activity/list',
        icon: '/media/icons/duotune/general/gen016.svg',
        title: 'Activity',
        module: 'activity',
        fontIcon: 'bi-app-indicator',
    },
    {
        to: '',
        title: 'Communication',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/communication/com005.svg',
        module: 'communication',
        subMenuItems: [

            {
                to: 'admin/communication/sms',
                title: 'SMS',
                hasBullet: true,
                module: 'communication'
            },
            {
                to: 'admin/communication/whatsapp',
                title: 'Whatsapp',
                hasBullet: true,
                module: 'communication'
            },
            {
                to: 'admin/communication/email',
                title: 'Email',
                hasBullet: true,
                module: 'communication',
            },
            {
                to: '/apps/company-management/calling_document',
                hasBullet: true,
                title: 'Document Upload',
                module: 'company-management',
            },
            {
                to: 'admin/communication/com-log',
                title: 'All Logs',
                hasBullet: true,
                module: 'communication',
            },

        ],
    },
    {
        to: '/admin/media/list',
        icon: '/media/icons/duotune/communication/com009.svg',
        title: 'Comm. Media',
        fontIcon: 'bi-app-indicator',
        module: 'Media'
    },
    {
        to: '',
        title: 'FAQs',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/text/txt004.svg', module: 'FAQs',
        subMenuItems: [

            {
                to: '/admin/faq/category_faq',
                hasBullet: true,
                title: 'Category', module: 'FAQs',
            },
            {
                to: '/admin/faq/list',
                hasBullet: true,
                title: 'List', module: 'FAQs',
            },
        ],
    },


    {
        to: '',
        title: 'Settings',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/coding/cod001.svg',
        module: 'project_settings',
        subMenuItems: [
            {
                to: '/apps/company-management/offer/list',
                hasBullet: true,
                title: 'Add Offers Details',
                module: 'project_settings',

            },
            {
                to: '/apps/company-management/pages',
                hasBullet: true,
                title: 'Pages', module: 'project_settings',
            },
            {
                to: '/apps/company-management/support',
                hasBullet: true,
                title: 'Support', module: 'project_settings',
            },
            {
                to: '/apps/company-management/project_config',
                hasBullet: true,
                title: 'Project Config', module: 'project_settings',
            },
        ],
    },


    {
        to: '',
        title: 'Reports',
        fontIcon: 'bi-archive',
        icon: '/media/icons/duotune/files/fil025.svg',
        module: 'reports',
        subMenuItems: [
            {
                to: '/admin/reports/new_reports',
                title: 'ALL Reports',
                hasBullet: true,
                module: 'reports',
            },
        ],
    },
    {
        to: '/apps/company-management/invoices',
        title: 'Invoices',
        icon: '/media/icons/duotune/ecommerce/ecm004.svg',
        module: 'company-management',
        fontIcon: 'bi-app-indicator',
    },
];